<template>
    <div>
        <b-container class="search-box shadow">
            <b-form-group >
                <div class="form-row">
                    <b-input-group>
                        <b-form-input 
                            v-model="newEmail" 
                            placeholder="email..."
                            :state=newEmailState 
                            class="form-control" />
                        <b-input-group-append>
                            <b-button @click="addReviewer">Add {{reviewerText}}</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </b-form-group>
        </b-container>
        <b-container class="search-box shadow">
            <div class="form-row">
                <b-textarea
                    v-model="message"
                    placeholder="Optional: Add a custom message for the new reviewers"
                    rows="2"
                    max-rows="6"
                    v-on:blur="emitNewMessage"
                    >
                </b-textarea>
            </div>
        </b-container>
        <b-container class="review-table"> 
            <b-table class="table-responsive" :items="revs"
                :fields="fields">
                <template v-slot:cell(action)="{ item }">
                    <font-awesome-icon 
                        @click="deleteReviewer(item.email)"
                        :icon="['fas', 'minus-square']">
                    </font-awesome-icon>
                </template>
                <template v-slot:cell(addedDate)='{ item }'>
                    <div v-if="item.addedDate">
                    {{new Date(item.addedDate)}}
                    </div>
                </template>
                <template v-slot:cell(lastViewed)='{ item }'>
                    <div v-if="item.lastViewed">
                    {{new Date(item.lastViewed)}}
                    </div>
                </template>
                <template v-slot:cell(state)='{ item }'>
                    <font-awesome-icon v-if="item.state=='complete'"
                        :icon="['fa', 'check']">
                    </font-awesome-icon>
                </template>
                <template v-slot:cell(completeDate)='{ item }'>
                    <div v-if="item.completeDate">
                    {{new Date(item.completeDate)}}
                    </div>
                </template>
            </b-table>
            <div class="form-row" v-if="isReviewers">
                <b-form-checkbox 
                    v-model="sendReminder">
                    Send reminder to all reviewers
                </b-form-checkbox>
            </div>
        </b-container>
    </div>
</template>

<script>

export default {
    name: "Reviewers",
    props: [
        "reviewers",
        "sharing"
    ],
    data() {
        return {
            message: null,
            newEmail: null,
            r: null
        }
    },
    computed: {
        fields: function() {
            let f = [
                {
                    key: 'action',
                    label: '',
                },
                {
                    key: 'email',
                    label: 'e-mail',
                    sortable: true
                },
                {
                    key: 'addedDate',
                    label: 'Added On',
                    sortable: true
                }
            ]
            if(this.isReviewers) {
                f.push(...[
                    {
                        key:'lastViewed',
                        label: 'Last Viewed',
                        sortable: true
                    },
                    {
                        key: 'state',
                        label: 'Completed',
                        sortable: true
                    },
                    {
                        key:'completeDate',
                        label: 'Date Completed',
                        sortable: true
                    }
                ])
            }
            f.push({
                key: 'role',
                label: 'Role',
                sortable: true
            })
            return f;
        },
        reviewerText: function() {
            if(this.isReviewers)
                return "Reviewer"
            else
                return "Viewer"
        },
        revs: {
            get: function() {
                if( this.r )
                    return this.r
                return this.reviewers.map(a => {return {
                    email:a.email, 
                    state: a.state, 
                    lastViewed: a.lastViewed, 
                    completeDate: a.completeDate,
                    addedDate: a.addedDate,
                    role: a.role
                }})
            }
        },
        sendReminder: {
            get: function() {
                return this.reminder;
            },
            set: function(reminder) {
                this.$emit("sendReminder", reminder);
                this.reminder = reminder;
            }
        },
        newEmailState() {
            return this.newEmail && this.validateEmail(this.newEmail)
        },
        isReviewers() {
            return !this.sharing
        },
        reviewerType() {
            return this.isReviewers ? "reviewer" : "viewer"
        }
    },
    methods: {
        addReviewer() {
            if(!this.r)
                this.r = this.revs.slice(0)

            let email = this.newEmail
            if(email) {
                email = email.trim().toLowerCase()
            }
            if(this.r.findIndex(a => a.email == email) == -1) {
                this.r.unshift( {email, addedDate: new Date(), role: this.reviewerType} )
                this.$emit("addReviewer", email, this.reviewerType)
            }
            this.newEmail=null
        },
        deleteReviewer(row) {
            if (!this.r)
                this.r = this.revs.slice(0)

            let email = row
            let idx = this.r.findIndex(a => a.email == email)
            if(idx != -1) {
                this.r.splice(idx, 1)
                this.$emit("deleteReviewer", row)
            }
        },
        emitNewMessage() {
            this.$emit('reviewMessage', this.message)
        },
        validateEmail(email) {
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
        },

    }        
}
</script>